import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrashFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.6999 2.45L8.3999 4.4H2.9999C2.66853 4.4 2.3999 4.66863 2.3999 5C2.3999 5.33137 2.66853 5.6 2.9999 5.6H20.9999C21.3313 5.6 21.5999 5.33137 21.5999 5C21.5999 4.66863 21.3313 4.4 20.9999 4.4H15.5999L14.2999 2.45C14.1199 2.17 13.7999 2 13.4699 2H10.5399C10.1999 2 9.8899 2.17 9.6999 2.45ZM3.4999 7.39999C3.16853 7.39999 2.8999 7.66862 2.8999 7.99999C2.8999 8.33136 3.16853 8.59999 3.4999 8.59999H5.08575L6.8799 21.14C6.9499 21.63 7.3699 22 7.8699 22H16.1299C16.6299 22 17.0499 21.63 17.1199 21.14L18.9141 8.59999H20.4999C20.8313 8.59999 21.0999 8.33136 21.0999 7.99999C21.0999 7.66862 20.8313 7.39999 20.4999 7.39999H3.4999ZM10.5999 12C10.5999 11.6686 10.3313 11.4 9.9999 11.4C9.66853 11.4 9.3999 11.6686 9.3999 12V18C9.3999 18.3314 9.66853 18.6 9.9999 18.6C10.3313 18.6 10.5999 18.3314 10.5999 18V12ZM14.5999 12C14.5999 11.6686 14.3313 11.4 13.9999 11.4C13.6685 11.4 13.3999 11.6686 13.3999 12V18C13.3999 18.3314 13.6685 18.6 13.9999 18.6C14.3313 18.6 14.5999 18.3314 14.5999 18V12Z",
		fill: "currentColor"
	})
});
export default SvgTrashFill;
